import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { GA_MEASUREMENT_ID } from "../../../utils/analytics/analytics";

const RouteChangeTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  // Initialize GA4
  useEffect(() => {
    // Replace with your Measurement ID
    ReactGA.initialize(GA_MEASUREMENT_ID);
    setInitialized(true);
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (initialized) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [initialized, location]);

  return null; // This component does not render anything
};

export default RouteChangeTracker;
